import { useState } from 'react';
import { useTranslation } from 'react-i18next';


const FORM_URL = 'https://readdy.ai/api/form/d79qvor2hsar0k5m0rrg';

export default function PreorderForm() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const data = new URLSearchParams();
    data.append('email', email);
    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <section id="preorder" className="w-full bg-[#F5EEE4] py-24 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <span className="inline-block text-xs tracking-[0.3em] uppercase font-label text-stone-400 mb-5">
          {t('preorder_label')}
        </span>
        <h2 className="font-zh-serif text-4xl md:text-5xl text-stone-900 font-light mb-4 leading-tight">
          {t('preorder_title')}
        </h2>
        <p className="text-stone-500 text-base font-light max-w-md mx-auto leading-relaxed mb-10">
          {t('preorder_subtitle')}
        </p>

        {submitted ? (
          <div className="flex flex-col items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-stone-200">
              <i className="ri-check-line text-stone-700 text-2xl" />
            </div>
            <p className="text-stone-700 text-lg font-medium">{t('preorder_success_title')}</p>
            <p className="text-stone-400 text-sm font-light max-w-xs leading-relaxed">
              {t('preorder_success_msg')}
            </p>
          </div>
        ) : (
          <form
            data-readdy-form
            id="nimo-preorder-form"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('preorder_email_ph')}
              className="flex-1 border border-stone-300 rounded-lg px-5 py-3.5 text-sm text-stone-800 placeholder-stone-300 focus:outline-none focus:border-stone-500 transition-colors bg-white"
            />
            <button
              type="submit"
              disabled={submitting}
              className="w-[52px] h-[52px] flex-shrink-0 flex items-center justify-center rounded-lg overflow-hidden border border-stone-200 hover:border-stone-400 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed bg-white p-0.5"
              title={submitting ? t('preorder_submitting') : t('preorder_submit')}
            >
              <img
                src="https://storage.readdy-site.link/project_files/09ac3b88-05d8-4a69-af11-22c685bd56bb/4ea01870-c145-47a0-a27f-c6f6d4a33531__20260408145425.png"
                alt="QR Code"
                className="w-full h-full object-contain"
              />
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
